"use strict";
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
module.exports = function createComponent({ name, baseClass, baseTag, }) {
    if (!baseTag)
        throw new Error(`createComponent(${name}): baseTag not provided. This should never happen`);
    const cls = [baseTag.className, baseClass].filter(x => x).join(' ');
    const result = react_1.default.forwardRef(({ Tag = baseTag, className, children, ...rest }, ref) => {
        for (const key in rest) {
            if (key.startsWith('data-') && typeof rest[key] === 'boolean') {
                if (rest[key])
                    rest[key] = '';
                else
                    delete rest[key];
            }
        }
        return react_1.default.createElement(Tag, {
            ...rest,
            className: `${Tag.className || ''} ${className || ''} ${cls}`.trimStart(),
            ref
        }, children);
    });
    return Object.assign(result, {
        displayName: `${name}(${baseTag.displayName || baseTag})`,
        withComponent: (baseTag) => createComponent({ name, baseClass: cls, baseTag }),
        className: baseClass,
    });
};
//# sourceMappingURL=createComponent.js.map